export default {
  'approvers.title': 'Configuración de Aprobadores',

  // Criterion nouns after "por" stay singular (one group / position / area / entity per rule).
  'approvers.types.userGroup.description': 'Aprobadores globales por grupo de usuarios',
  'approvers.types.groupAndPosition.description':
    'Aprobadores globales por grupo de usuarios y puesto',
  'approvers.types.globalUserGroupAndArea.description':
    'Aprobadores globales por grupo de usuarios y área',
  'approvers.types.entity.description': 'Aprobadores globales por entidad y usuario',
  'approvers.types.entityAndUserGroup.description':
    'Aprobadores globales por entidad y grupo de usuarios',
  'approvers.types.entityAndPosition.description': 'Aprobadores globales por entidad y puesto',
  'approvers.types.globalEntityAndArea.description': 'Aprobadores globales por entidad y área',
  'approvers.level': 'Nivel de Aprobación',
  'approvers.dynamicEntity': 'Entidad Dinámica',
  'approvers.dynamicEntityField': 'Campo',
  'approvers.fieldData': 'Valor',
  'approvers.area': 'Área',
  'approvers.entityValue': 'Valor de Entidad',

  'approvers.userGroup.title': 'Gestionar Aprobadores Globales por Grupo de Usuarios',
  'approvers.userGroupPosition.title':
    'Gestionar Aprobadores Globales por Grupo de Usuarios y Puesto',
  'approvers.dynamicEntityUser.title': 'Gestionar Aprobadores Globales por Entidad y Usuario',
  'approvers.dynamicEntityUserGroup.title':
    'Gestionar Aprobadores Globales por Entidad y Grupo de Usuarios',
  'approvers.dynamicEntityPosition.title': 'Gestionar Aprobadores Globales por Entidad y Puesto',

  'approvers.globalArea.title': 'Gestionar Aprobadores Globales por Grupo de Usuarios y Área',

  'approvers.entityArea.title': 'Gestionar Aprobadores Globales por Entidad y Área',
};
